var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 4.25H4.25C3.55965 4.25 3 4.80965 3 5.5V25.5C3 26.1904 3.55965 26.75 4.25 26.75H26.75C27.4404 26.75 28 26.1904 28 25.5V5.5C28 4.80965 27.4404 4.25 26.75 4.25ZM15.5 20.5C13.4289 20.5 11.75 18.8211 11.75 16.75H5.5V6.75H25.5V16.75H19.25C19.25 18.8211 17.5711 20.5 15.5 20.5ZM20.5 11.75H16.75V8H14.25V11.75H10.5L15.5 17.375L20.5 11.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportFill);
export default __webpack_public_path__ + "static/media/import-fill.aac472fc72cc58eefe8521aac0c7e145.svg";
export { ForwardRef as ReactComponent };